import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { RESPONSE_STATUS, TEXT_CONSTANTS } from "../../utils/constants";
import "./calendar.css";
import AgendaTasks from "./AgendaTasks/AgendaTasks";
import Shimmer from "../Shimmer/shimmer";
import TimeLine from "./TimeLine/TimeLine";
import Icon from "../../dashboard/Icon/Icon";
import LSQTabMenu from "../ReusableComponents/LSQTabMenu/LSQTabMenu";
import LSQDateSelector from "../ReusableComponents/LSQDateSelector/LSQDateSelector";
import { fetchCalendarData } from "./helper/helper";
import LSQFrame from "../ReusableComponents/LSQFrame/LSQFrame";
import analytics from "../../utils/analytics";
export const hourHeight = 90;
export const maxTasksInRow = 2;

const Calendar = ({ widget = {}, activeDashboardId, forceRefresh }) => {
  const { config } = widget;
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [tasks, setTasks] = useState({
    responseStatus: RESPONSE_STATUS.requestPending,
  });
  const [initialLoad, setInitialLoading] = useState(true);

  const [activeIndex, setActiveIndex] = useState(0);
  const events = tasks.response || [];
  const fetchData = (forceRefresh = false) =>
    fetchCalendarData(
      selectedDate,
      setTasks,
      activeDashboardId,
      widget,
      forceRefresh
    );

  useEffect(() => {
    fetchData();
  }, [selectedDate]);

  useEffect(() => {
    if (initialLoad) setInitialLoading(false);
    else {
      fetchData(true);
    }
  }, [forceRefresh]);

  let content;
  if (tasks.responseStatus === RESPONSE_STATUS.requestPending)
    content = <Shimmer width="100%" height="100%" />;
  else if (tasks.responseStatus === RESPONSE_STATUS.requestRejected)
    content = (
      <LSQFrame className="calendar-retry" role="calendar-retry">
        <Icon src={"assets/icons/error_state.svg"} alt="icon" isWidgetIcon={false} />
        <div className="content">
          <label className="ng_sh_r">{TEXT_CONSTANTS.somethingWentWrong}</label>
          <button className="ng_sh_r" onClick={fetchData}>{TEXT_CONSTANTS.retry}</button>
        </div>
      </LSQFrame>
    );
  else if (
    tasks.responseStatus === RESPONSE_STATUS.requestFullfilled &&
    events.length === 0
  )
    content = (
      <LSQFrame className="calender-empty" role="calendar-empty">
        <Icon src={"assets/icons/empty_state.svg"} alt="icon" isWidgetIcon={false} />
        <label className="ng_sh_r">{TEXT_CONSTANTS.noTasksScheduled}</label>
      </LSQFrame>
    );
  const tabMenuOptions = {
    options: [
      { label: "Timeline", value: 0 },
      { label: "Agenda", value: 1 },
    ],
    activeIndex,
    onTabChange: (e) => {
      if (e.value.value === activeIndex) {
        return;
      }
      setActiveIndex(e.value.value);

      const analyticsData = {
        category: "widget_click",
        type: "click"
      };
      analytics.sendEvent(`calendarview tab changed to ${e?.value?.label}`, analyticsData);
    },
  };

  const onDateClick = () => {
    const analyticsData = {
      category: "widget_click",
      type: "click"
    };
    analytics.sendEvent("calendarview datepicker opened", analyticsData);
  }

  return (
    <div className="calendar-main">
      <div className="calendar-header overflow-ellipsis ng_sh_r">
        <Icon
          src={`images/${config?.icon?.imgName || "lsq_copy"}.svg`}
          alt="icon"
          isWidgetIcon={false}
        />
        <label className="overflow-ellipsis ng_sh_sb" title={config?.name}>
          {config?.name || "Calendar"}
        </label>
      </div>
      <LSQTabMenu optionClassName="small" {...tabMenuOptions} />
      <LSQDateSelector
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        onDateClick={onDateClick}
      />
      {content ||
        (activeIndex === 0 ? (
          <TimeLine events={events} selectedDate={selectedDate} />
        ) : (
          <AgendaTasks events={events} />
        ))}
    </div>
  );
};

export default Calendar;
